import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { svgIconStyles as t } from "../svg-icon/SvgIcon.styles.js";
function c({
  label: e,
  className: o,
  size: l,
  ...n
}) {
  return /* @__PURE__ */ r(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "meinsFill",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: t({ className: o, size: l }),
      ...n,
      children: [
        e && /* @__PURE__ */ i("title", { children: e }),
        /* @__PURE__ */ i(
          "path",
          {
            d: "M6.99997 7C6.99997 4.23858 9.23855 2 12 2 14.7614 2 17 4.23858 17 7 17 9.76142 14.7614 12 12 12 9.23855 12 6.99997 9.76142 6.99997 7ZM4.06187 22C2.98409 22 2.12862 21.0597 2.44826 20.0305 3.71308 15.9576 7.51113 13 12 13 16.4888 13 20.2869 15.9576 21.5517 20.0305 21.8713 21.0597 21.0159 22 19.9381 22H4.06187Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  c as MeinsFillIcon,
  c as default
};
